<template>
<div class="my-pagination">
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="queryParams.pageIndex || queryParams.page"
    :page-sizes="pageSizes"
    :page-size="queryParams.pageSize || queryParams.per_page"
    layout="prev, pager, next, jumper, sizes, total"
    :total="queryParams._total">
  </el-pagination>
</div>
</template>

<script>
// 注意：为了进行更快的开发，页码组件进行了更严格的封装：页面请求的参数对象里面需要定义pageSize为页面条数，pageIndex为当前页数，_total为总条数，getList方法中返回的数值不要遗漏将总条数为total赋值
import { pageSizes } from '../../utils/Config.js'
export default {
  name: "Pagination",
  props: {
    queryParams: { // 页面上的页码参数，需要参与列表接口请求的
      type: Object,
      default: () => {}
    },
    getList: { // 页面的列表请求方法
      type: Function,
      default: () => {}
    }
  },
  computed: {
    pageSizes() {
      return pageSizes
    }
  },
  methods: {
    handleSizeChange(size) {
      // 页数切换方法
      if (this.queryParams.pageSize) {
        this.queryParams.pageSize = size
      }else{
        this.queryParams.per_page = size
      }
      if (this.queryParams.pageIndex) {
        this.queryParams.pageIndex = 1
      }else{
        this.queryParams.page = 1
      }
      this.getList()
    },
    handleCurrentChange(index) {
      if (this.queryParams.pageIndex) {
        this.queryParams.pageIndex = index
      }else{
        this.queryParams.page = index
      }
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
  .my-pagination {
    margin: 10px 0;
    /deep/ .el-pagination {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>